export const SET_PRAESENZ_STATI = "setAnwesenheitStati";
export const SET_TEILPRAESENZEN = "setTeilpraesenzen";